import { getDateIncluded, getOffsetDate, databaseDate } from 'shared/intrasyncUtils';
import { RouteType } from "types/RouteType";
import type { SchedulingToolbarConfig } from "types/scheduling.types";
import { PRODUCTION_SCHEDULE_CONFIG } from "./productionScheduleViewModes.config";
// import { utils } from 'shared/intrasyncUtils';
import { toJS } from "mobx";
import { ServiceStore, RootStore } from "@intrasync/stores";
// import { getOffsetDate } from 'shared/intrasyncUtils';
// import IfcOverviewIcon from '@mui/icons-material/GridOn';
// import { toJS } from 'mobx';

type JobStat = {
  panelStatsTotal?: {
    startCasting?: string;
    endCasting?: string;
  };
  jobNumber?: number;
};

// Scheduling Toolbar Configuration
const schedulingConfig: SchedulingToolbarConfig = {
  // Entity configuration
  entityName: 'Panel',
  entityNamePlural: 'Panels',
  dateField: 'castingDate',
  idField: 'id',

  // Store references
  serviceStore: 'panelStore',
  viewStore: 'productionOverviewScheduleStore',

  // Enabled actions
  enabledActions: {
    moveEarlier: true,
    moveLater: true,
    reschedule: true,
    removeFromSchedule: true,
    clearSelection: true,
  },

  // Custom action labels
  actionLabels: {
    moveEarlier: 'Cast Earlier',
    moveLater: 'Cast Later',
    reschedule: 'Recast',
  },

  // Date navigation config
  dateNavigation: {
    unit: 'day',
    skipWeekends: true,
    workdaysOnly: true,
  },
};

const productionScheduleRoute: RouteType[] = [
  {
    name: "Production Schedule",
    path: "/production-schedule",
    layout: "/app",
    schedulingConfig,
    viewportCard: {
      header: {
        title: "Production Schedule",
        component: () => import("./UnifiedProductionSchedule.Header"),
        enableRefreshButton: true,
        enableBackButton: true,
      },
      body: {
        // component: () => import('./IFCOverview.Body'),
        scheduleContainer: {
          namespace: "ProductionOverviewSchedule",
          storeName: "productionOverviewScheduleStore",
          dateKey: "castingDate",
          dateRangeKey: "dateRange",
          fixedRowCount: 1,
          rowHeight: (rowIndex: { index: number }, rootStore) => {
            if (rowIndex.index === 0) {
              return 50;
            }
            const store = rootStore?.productionOverviewScheduleStore;
            if (store && typeof store === 'object' && 'getRowHeight' in store) {
              return (store as any).getRowHeight(rowIndex.index);
            }
            return 100;
          },
          // height: 500,
          // width: 500,
        },
      },
    },
    // icon: IfcOverviewIcon,

    hidden: false,
    defaultQueryParams: {
      view: 'overall',
      startDate: getOffsetDate(databaseDate(), { offset: -14 }),
      endDate: getOffsetDate(databaseDate(), { offset: 56 }),
    },
    group: 'Scheduling',
    requiresAuth: true,
    requiresPermission: false,

    channels: [
      "dates/holidays",
      "job",
      "job",
      "ifc-status",
      "panel-revit",
      "panel-plant",
      "panel-yard",
      "hold",
      "job-stats/panel-count",
    ],
    enableAutoFind: false,
    beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
      const datesHolidaysStore = rootStore.datesHolidaysStore as ServiceStore;
      const jobStore = rootStore.jobStore as ServiceStore;
      const holdStore = rootStore.holdStore as ServiceStore;
      const jobStatsPanelCountStore =
        rootStore.jobStatsPanelCountStore as ServiceStore;

      // Initialize unified production schedule store with config
      const productionScheduleStore = rootStore.productionOverviewScheduleStore;
      if (productionScheduleStore && typeof productionScheduleStore === 'object' && 'setConfig' in productionScheduleStore) {
        (productionScheduleStore as any).setConfig(PRODUCTION_SCHEDULE_CONFIG);
      }

      // Set view mode from query params
      const viewMode = rootStore.routerStore?.queryParams?.view || 'overall';
      if (productionScheduleStore && typeof productionScheduleStore === 'object' && 'setViewMode' in productionScheduleStore) {
        (productionScheduleStore as any).currentViewMode = viewMode;
      }

      jobStatsPanelCountStore.find();
      datesHolidaysStore.find();
      jobStore.find();
      holdStore.find({
        query: {
          $limit: 2000,
        },
      });

      return true;
    },
    onEnter: async ({ rootStore, queryParams }) => {
      const jobStatsCastingDatesStore =
        rootStore.jobStatsCastingDatesStore as ServiceStore;

      const { startDate, endDate } = toJS(queryParams);

      const foundJobStats = await jobStatsCastingDatesStore.find();

      const foundJobStatsData = foundJobStats?.data as JobStat[];

      const jobInRange = foundJobStatsData.reduce((acc: number[], jobStat) => {
        let shouldInclude = false;
        if (
          jobStat?.panelStatsTotal?.startCasting &&
          jobStat?.panelStatsTotal?.endCasting
        ) {
          const checkIfStartIncluded = getDateIncluded(
            startDate as string,
            jobStat?.panelStatsTotal?.startCasting,
            jobStat?.panelStatsTotal?.endCasting
          );

          if (checkIfStartIncluded) {
            shouldInclude = true;
          }

          const checkIfEndIncluded = getDateIncluded(
            endDate as string,
            jobStat?.panelStatsTotal?.startCasting,
            jobStat?.panelStatsTotal?.endCasting
          );
          if (checkIfEndIncluded) {
            shouldInclude = true;
          }
        }

        if (shouldInclude) {
          acc.push(jobStat.jobNumber as number);
        }
        return acc;
      }, []);
      // console.log('Included Jobs', jobInRange);
      if (jobInRange.length) {
        const ifcStatusStore = rootStore.ifcStatusStore as ServiceStore;
        const panelStore = rootStore.panelStore as ServiceStore;
        // const panelStore = rootStore.panelStore as ServiceStore;
        // const panelStore = rootStore.panelStore as ServiceStore;
        // console.log('Included Jobs', jobInRange);
        for (const jobNumber of jobInRange) {
          // console.log('Job Number', jobNumber);
          ifcStatusStore.find({
            query: {
              jobNumber: jobNumber,
              $limit: 2000,
            },
          });
          panelStore.find({
            query: {
              jobNumber: jobNumber,
              $limit: 2000,
            },
          });
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
      }
    },

    onParamsChange: async ({ rootStore, queryParams, previousQueryParams }) => {
      if (previousQueryParams !== queryParams) {
        console.log("trigger enter effects");
        rootStore.routerStore?.triggerEnterSideEffects();
      }
    },
  },
];

export default productionScheduleRoute;
